import React from 'react';
import PropTypes from 'prop-types';
import StatusPill from '../../../shared/components/pill/StatusPill';
import { PILL_SIZES } from '../../../shared/components/pill/tones';

// Renders one of the state objects from integrationStates.js. Small, but it is the reason the
// health column, the sync log and the dashboard card cannot drift apart again: they all hand
// the same shape to the same component.
export default function StatePill({ state, size, className }) {
  return (
    <StatusPill tone={state.tone} icon={state.icon} size={size} className={className}>
      {state.label}
    </StatusPill>
  );
}

StatePill.propTypes = {
  state: PropTypes.shape({
    label: PropTypes.string.isRequired,
    tone: PropTypes.string.isRequired,
    icon: PropTypes.string,
  }).isRequired,
  size: PropTypes.oneOf(PILL_SIZES),
  className: PropTypes.string,
};

StatePill.defaultProps = {
  size: 'standalone',
  className: '',
};
